export default __webpack_public_path__ + "static/media/vmr-logo.0ffff4f5.svg";